export default __webpack_public_path__ + "static/media/nut-comic-2.4765cfbd.png";